export default {
  PRESENCE: 'PRESENCE',
  PATTERN: 'PATTERN',
  CUSTOM: 'CUSTOM',
};
